export const DEFAULT_Y_AXIS_SCALES = 1;
export const INDIVIDUAL_Y_AXIS_SCALES = 2;
export const ALL_Y_AXIS_SCALES = 3;

export const Y_AXIS_CUSTOMISATION_OPTIONS = [
    {
        name: 'default',
        value: DEFAULT_Y_AXIS_SCALES,
    },
    {
        name: 'individual',
        value: INDIVIDUAL_Y_AXIS_SCALES,
    },
    {
        name: 'all',
        value: ALL_Y_AXIS_SCALES,
    },
];

export const EnumDefinitions = {
    DEFAULT: DEFAULT_Y_AXIS_SCALES,
    INDIVIDUAL: INDIVIDUAL_Y_AXIS_SCALES,
    ALL: ALL_Y_AXIS_SCALES,
};

export const RIGHT_MARGIN_AXES = {
    0: 0,
    1: 60,
    2: 60,
    3: 120,
    4: 120,
    5: 120,
    6: 180,
};

export const LEFT_MARGIN_AXES = {
    0: 0,
    1: 60,
    2: 60,
    3: 60,
    4: 120,
    5: 180,
    6: 180,
};

export const OPPOSITE_AXES = {
    1: false, // first axis on left
    2: true, // second axis on right
    3: true, // second and third axis on right
    4: false, // fourth axis on left
    5: false,
};
